import React from 'react';

import { Link, Text } from '~/components';
import { FooterInfoContainer } from '~/views/auth/auth.styles';

const AgreementFooter: React.FC<Record<string, never>> = () => {
  return (
    <FooterInfoContainer>
      <Text>By clicking Sign Up, you agree to our&nbsp;</Text>
      {/* <Link>Terms of Use</Link>
      <Text>&nbsp;and&nbsp;</Text> */}
      <Link href="/privacy-policy.html">Privacy Policy</Link>
    </FooterInfoContainer>
  );
};

export default AgreementFooter;
